module.exports = __webpack_public_path__ + "img/DigitalAlbum1.34ae1985.jpg";